import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  readonly BASE_URL;
  constructor(private http: HttpClient) {
    this.BASE_URL = environment.API_URL;
  }

  get(uri: string, headers: any[] = []) {
    return this.http.get<any>(`${this.BASE_URL}/${uri}`, {
      headers: this.generateHeaders(headers),
    });
  }

  post(uri: string, payload: any, headers: any[] = []) {
    return this.http.post<any>(`${this.BASE_URL}/${uri}`, payload, {
      headers: this.generateHeaders(headers),
    });
  }
  downloadData(uri: string, payload: any): Observable<Blob> {
    return this.http.post(`${this.BASE_URL}/${uri}`, payload, {
      responseType: 'blob', // The 'blob' responseType is now valid
      // you can add other options here like withCredentials
    });
  }
  postFormData(uri: string, payload: any, headers: any[] = []) {
    var formData = new FormData();

    for (var key in payload) {
      // Only append if the value is not null and not undefined
      if (payload[key] !== null && payload[key] !== undefined) {
        formData.append(key, payload[key]);
      }
    }

    return this.http.post<any>(`${this.BASE_URL}/${uri}`, formData, {
      headers: this.generateHeaders(headers),
    });
  }

  postFormMultiData(uri: string, payload: any, headers: any[] = []) {
    let form_data = new FormData();
    const appendFormData = (
      formData: FormData,
      data: any,
      parentKey: string | null = null,
    ) => {
      if (Array.isArray(data)) {
        // Handle arrays -> append using "key[]"
        data.forEach((item) => {
          formData.append(`${parentKey}[]`, item);
        });
      } else if (data && typeof data === 'object' && !(data instanceof File)) {
        // Handle nested objects
        Object.keys(data).forEach((key) => {
          const fullKey = parentKey ? `${parentKey}[${key}]` : key;
          appendFormData(formData, data[key], fullKey);
        });
      } else {
        // Primitive values & Files
        if (parentKey) {
          formData.append(parentKey, data ? data : '');
        }
      }
    };
    appendFormData(form_data, payload);

    return this.http.post<any>(`${this.BASE_URL}/${uri}`, form_data, {
      headers: this.generateHeaders(headers),
    });
  }

  /** PAGE FUNCTIONS */
  generateHeaders(hdrs: any[]) {
    let headers = new HttpHeaders();
    for (const key in hdrs) {
      if (Object.prototype.hasOwnProperty.call(hdrs, key)) {
        const value = hdrs[key];
        headers = headers.append(key, value);
      }
    }

    return headers;
  }
}
